/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState, useCallback } from "react";
import Slider from "react-slick";
import { Outlet, useNavigate, useLocation, Link } from "react-router-dom";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BiRightArrowAlt } from "react-icons/bi";
import "./Category.css";
import CustomPlaybutton from "../../components/Buttons/CustomPlaybutton";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import bg from "../../assets/bg_image/banner.png";
import Page from "../../components/CatList/Page";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import Button from "../../components/Buttons/Button";
import MobileSlider from "../../components/CostomSlider/MobileSlider";
import { Allcommercials, commercials } from "../../data/CategoryData";
import { shortsanddocAssets } from "../../assets/shortsanddocumentaries";
import { PlayIcon } from "../../assets/Icons";
import { shortsAndDocData } from "../../data/data";
const Commercials = ({ pageHeading }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [playVideo, setPlayVideo] = useState(false);

  return (
    <div className="relative">
      <div className="px-4 md:px-[7.2vw] z-10 flex items-center pt-[25vw] md:pt-[10.29vw]">
        <Pageheading pageHeading={pageHeading} icon={<RiHome2Line />} />
      </div>
      <section className="w-full px-4 py-6 md:px-[7.2vw] md:py-[4.7vw]">
        {/* <h2 className="w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          SHORTS & DOCUMENTARIES
        </h2> */}

        <h2 className="w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          SHORTS & DOCUMENTARIES
        </h2>

        <div className="grid grid-cols-2 tab:grid-cols-4 gap-[10px] md:gap-10 mt-8">
          {shortsAndDocData?.map((data, i) => (
            <Link
              key={`shortsanddocs-${i}`}
              to={`details/${data?.videoId}`}
              className="aspect-[4/5] relative"
            >
              <img
                src={data?.background}
                alt="Background Image"
                className="object-cover"
              />
              <img
                src={PlayIcon}
                alt="Play Icon"
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 !size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
              />
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Commercials;
